import React from 'react';
import { keyframes, styled } from 'styled-components';
import ai from '../assets/images/ai.svg';
const defaultSize = '16px';
const AI = (props) => {
    const height = props.height ?? props.width ?? defaultSize;
    const width = props.width ?? props.height ?? defaultSize;
    const isDisabled = props.disabled ?? false;
    return (React.createElement(Wrapper, { onClick: (...args) => {
            if (props.onClick != null &&
                !isDisabled &&
                (props.loading == null || !props.loading)) {
                props.onClick(...args);
            }
        }, clickable: props.onClick != null && !isDisabled, floating: props.floating ?? false, "data-tooltip-id": props['data-tooltip-id'], "data-tooltip-content": props['data-tooltip-content'], "data-tooltip-delay-show": 1000 },
        React.createElement(Img, { className: "ai", src: ai, width: width, height: height, $disabled: isDisabled, alwaysAnimated: props.loading != null
                ? (props.loading ?? props.alwaysAnimated ?? false)
                : (props.alwaysAnimated ?? false) }),
        React.createElement(Loading, { className: "ai", loading: props.loading ?? false, width: width, height: height }),
        props.content != null ? (React.createElement(Content, { showOnHover: props.showContentOnHover ?? false }, props.content)) : null));
};
const Wrapper = styled.div `
  display: inline-flex;
  align-items: center;

  flex-shrink: 0;

  background: #fff;

  border: ${(props) => (props.content ? '1px solid lightgray' : 'none')};
  box-shadow: ${(props) => props.content && props.floating
    ? '0px 1px 4px 0px rgba(0,0,0,0.3)'
    : 'none'};
  padding: ${(props) => (props.content ? '4px' : '0px')};
  padding-right: ${(props) => (props.content ? '8px' : '0px')};
  border-radius: 10000px;

  cursor: ${(props) => (props.clickable ? 'pointer' : 'auto')};

  &:hover img {
    opacity: 1;
    animation-play-state: running;
  }

  &:hover div {
    opacity: 1;
    pointer-events: auto;
  }
`;
const rotateLoader = keyframes `
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const Loading = styled.div `
  transition: border-color 200ms ease;

  position: absolute;
  border: 2px solid rgba(0, 0, 0, 0);
  border-radius: 1000000px;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  border-bottom: none;
  border-top: none;

  border-color: ${(props) => (props.loading ? 'white' : 'rgba(0,0,0,0)')};

  animation: ${rotateLoader} 3s linear infinite;
`;
const Content = styled.div `
  transition: opacity ease-in-out 300ms;
  opacity: ${(props) => (props.showOnHover ? '0' : '1')};
  pointer-events: ${(props) => (props.showOnHover ? 'none' : 'auto')};
`;
const saturate = keyframes `
  0% {
    filter: saturate(1) brightness(1) hue-rotate(0deg);
  }

  20% {
    filter: saturate(1.5) brightness(1.2) hue-rotate(-2deg);
  }

  40% {
    filter: saturate(1.5) brightness(1) hue-rotate(0deg);
  }

  60% {
    filter: saturate(1.5) brightness(1) hue-rotate(-2deg);
  }

  80% {
    filter: saturate(1.25) brightness(1) hue-rotate(0deg);
  }

  100% {
    filter: saturate(1.5) brightness(1) hue-rotate(0deg);
  }
`;
const Img = styled.img `
  transition: opacity 300ms ease-in-out;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  opacity: ${(props) => (props.$disabled ? '0.4' : '1')};
  filter: ${(props) => (props.$disabled ? 'grayscale(100%)' : 'none')};
  animation-name: ${(props) => (props.$disabled ? 'none' : saturate)};
  animation-duration: 5s;
  animation-timing-function: ease-in-out;
  animation-direction: alternate;
  animation-iteration-count: infinite;
  animation-play-state: ${(props) => props.alwaysAnimated ? 'running' : 'paused'};

  margin-right: ${(props) => (props.content != null ? '0.25em' : '0')};

  &:hover {
    opacity: ${(props) => (props.$disabled ? '0.4' : '1')};
    animation-play-state: ${(props) => (props.$disabled ? 'paused' : 'running')};
  }
`;
export default AI;
//# sourceMappingURL=AI.js.map